// components/Layout.tsx

import React, { ReactElement, ReactNode } from 'react';
import { NextPage } from 'next';
import { AppProps } from 'next/app';
import GeneralFooter from './Footer';
import Navbar from './Navbar';
import { Toaster } from '@/components/ui/toaster';
import WelcomeModal from '@/components/welcomeModal';

export type NextPageWithLayout<P = object, IP = P> = NextPage<P, IP> & {
  getLayout?: (page: ReactElement) => ReactNode;
};

export type AppPropsWithLayout = AppProps & {
  Component: NextPageWithLayout;
};

const Layout = (page: ReactElement) => {
  return (
    <div className='flex flex-col h-full min-h-screen justify-between max-w-[full] mx-auto pr-1'>
      <Navbar isVisibleItems={true} />
      <div className='flex-grow flex-1 h-full min-h-full'>{page}</div>
      <GeneralFooter />
      <Toaster />
    </div >
  );
};
function withGeneralLayout(c: any) {
  c.getLayout = Layout;
  return c;
}
export default withGeneralLayout;
